import { User } from "./user";

export class DocNotification {
    id:number = 0;
    user_id:number = 0;
    user:User = new User;
    document_type:string = "requisition";
    action_type:string = "create";
}
